<template>
  <dialog-wrapper>
    <v-dialog :value="true" max-width="500" @input="$emit('input')">
      <v-card>
        <v-card-title class="headline">
          <slot name="header" />
        </v-card-title>
        <v-card-text>
          <slot name="body" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="$emit('input');"><span v-t="'common.no'" /></v-btn>
          <v-btn color="primary" flat @click="$emit('confirm'); $emit('input');"><span v-t="'common.yes'" /></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </dialog-wrapper>
</template>

<script>
import DialogWrapper from '../../common/dialog-wrapper/DialogWrapper.vue';

export default {
  name: 'UnsavedChangesModal',
  components: { DialogWrapper },
};
</script>
